/**
 * Strip the most common markdown syntax characters so a post body can be
 * shown as a flat preview in a card. Not a full parser — just enough to
 * keep the feed readable. Cards never render formatting; the detail page
 * renders the full markdown via {@code PostBody}.
 */
export function stripMarkdown(source: string): string {
  return source
    // Fenced code blocks → keep the content but drop the fences.
    .replace(/```[\s\S]*?```/g, (block) =>
      block.replace(/```[a-zA-Z0-9_-]*\n?|\n?```/g, ''),
    )
    // Images: ![alt](url) → alt (the alt is usually the descriptive bit).
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
    // Links: [text](url) → text
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    // Headings: leading # ## ### …
    .replace(/^#{1,6}\s+/gm, '')
    // Blockquote markers
    .replace(/^>\s?/gm, '')
    // Unordered list bullets
    .replace(/^\s*[-*+]\s+/gm, '')
    // Ordered list markers ("1. ")
    .replace(/^\s*\d+\.\s+/gm, '')
    // Bold/italic emphasis: **x**, __x__, *x*, _x_
    .replace(/(\*\*|__)(.*?)\1/g, '$2')
    .replace(/(\*|_)(.*?)\1/g, '$2')
    // Inline code: `x`
    .replace(/`([^`]+)`/g, '$1')
    // Horizontal rules
    .replace(/^\s*(?:---|\*\*\*|___)\s*$/gm, '')
    // Collapse 3+ newlines to 2 so the line-clamp doesn't waste lines on whitespace.
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
